import { signOut } from 'aws-amplify/auth';

import { MODAL_META } from 'utils/constants';

const handleError = async (status, errorData, navigateFunc) => {
  const intercomObj = document.getElementById('intercom-frame');
  const handledStatusCodes = [400, 401, 403];
  let errorInfo = { message: '', errorType: '', details: null };

  if (!status) {
    return {
      message:
        'Network error or server unavailable. Please check your connection.',
      errorType: 'network',
      details: errorData || null,
    };
  }

  const type = errorData?.type || null;
  const detail = errorData?.detail || errorData?.message;
  const data = errorData?.data || null;

  if (status === 401 || status === 403) {
    if (intercomObj) {
      window.Intercom('shutdown');
    }
    try {
      await signOut();
    } catch (error) {
      console.error('❌ Error signing out:', error);
      alert('Error on exit: ' + error.message);
    }
  }

  if (status === 400 || status === 422) {
    switch (type) {
      case 'notEnoughCredits':
        errorInfo.message = detail;
        errorInfo.errorType = type;
        break;

      case 'validationError':
        errorInfo.message = `${MODAL_META.error.imageError}`;
        errorInfo.details = data.errors;
        errorInfo.errorType = type;
        break;

      case 'orderMissingRequiredFields:Title':
        errorInfo.message = detail || 'Missing required order field: Title.';
        errorInfo.details = detail;
        errorInfo.errorType = type;
        break;

      default:
        errorInfo.message = `${MODAL_META.error.message}`;
        errorInfo.errorType = type || 'unknown';
    }
  }

  if (!handledStatusCodes.includes(status)) {
    errorInfo.message = `${MODAL_META.error.message}`;
    errorInfo.errorType = type || 'unknown';
  }

  return errorInfo;
};

export default handleError;
